import {MenuPlatform} from "../groupCode/menuPlatformFilter";

/** DB 메뉴 통합 진입 URL */
export const REPORT_CODE_ENTRY_ROUTE = "/settings/report";

export const REPORT_CODE_CATEGORIES = [
    {
        id: "inspectionReport",
        label: "점검보고서 관리코드",
        title: "점검보고서 관리코드",
        description: "점검보고서 양식과 관리 항목을 설정합니다.",
        route: REPORT_CODE_ENTRY_ROUTE,
        addLabel: "점검보고서",
        platform: MenuPlatform.ITM,
    },
    {
        id: "dailyCheck",
        label: "일일체크코드",
        title: "일일체크코드",
        description: "일일체크 항목과 결재라인을 설정합니다.",
        route: REPORT_CODE_ENTRY_ROUTE,
        addLabel: "일일체크",
        platform: MenuPlatform.ITM,
    },
];

export const REPORT_CODE_ROUTE_CATEGORY = {
    [REPORT_CODE_ENTRY_ROUTE]: "inspectionReport",
    "/settings/report/inspectionReportCode": "inspectionReport",
    "/settings/report/dailyCheck": "dailyCheck",
};

export function parseReportCodeRoute(pathname) {
    if (pathname === REPORT_CODE_ENTRY_ROUTE) {
        return {categoryId: "inspectionReport", itemId: null, isCreate: false};
    }

    const inspectionId = pathname.match(
        /^\/settings\/report\/inspectionReportCode(?:\/update)?\/(\d+)$/,
    );
    if (inspectionId) {
        return {categoryId: "inspectionReport", itemId: Number(inspectionId[1]), isCreate: false};
    }
    if (pathname === "/settings/report/inspectionReportCode/create") {
        return {categoryId: "inspectionReport", itemId: null, isCreate: true};
    }
    if (pathname.startsWith("/settings/report/inspectionReportCode")) {
        return {categoryId: "inspectionReport", itemId: null, isCreate: false};
    }

    const dailyId = pathname.match(
        /^\/settings\/report\/dailyCheck(?:\/update)?\/(\d+)$/,
    );
    if (dailyId) {
        return {categoryId: "dailyCheck", itemId: Number(dailyId[1]), isCreate: false};
    }
    if (pathname === "/settings/report/dailyCheck/create") {
        return {categoryId: "dailyCheck", itemId: null, isCreate: true};
    }
    if (pathname.startsWith("/settings/report/dailyCheck")) {
        return {categoryId: "dailyCheck", itemId: null, isCreate: false};
    }

    return {categoryId: null, itemId: null, isCreate: false};
}
